/*
* Association common area amenities form view for authenticated users
*/

import * as React from 'react';
import * as _ from 'lodash';
// import { Row } from 'react-bootstrap';

import * as DetailFormCommon from './common';
import * as KendoWrappers from '../../common/kendoforms/componentwrappers';
// import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';

export const AssociationDetails = ({
    appText,
    handleFormInputChange,    
    handleSubmitForm,
    handleSaveChanges,
    numFormChanges,    
    formData,
    defaultInputProps,
    sectionTitle,
    ...rest }) => {
    if (!appText || !formData) { return (<div />); }

    let inputPropsVirtualizedSelect = _.merge({}, defaultInputProps, {
        // onChange: (o) => { handleFormInputChange({target: { type: 'virtualized-select' }}, o); }
    });

    return (
        <DetailFormCommon.AssociationDetailFormSection title={sectionTitle}>
            <div>               
                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="associationType.associationTypeId"                                                
                        label={appText('association-type')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.associationType.associationTypeId}
                        options={formData.options.associationTypes}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'associationType.associationTypeId', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="company.companyId"                                                
                        label={appText('company')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.company.companyId}
                        options={formData.options.companyTypes}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'company.companyId', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="client.clientId"                                                
                        label={appText('client')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.client.clientId}
                        options={formData.options.clients}
                        onChange={(o) => { handleFormInputChange({target: { name: 'client.clientId', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>
             
                <div>
                    <KendoWrappers.KendoVirtualizedSelectInput
                        name="contact.contactId"
                        label={appText('contact')}
                        labelKey="text"
                        valueKey="value"
                        value={formData.contact.contactId}
                        options={formData.options.clientContacts}                        
                        onChange={(o) => { handleFormInputChange({target: { name: 'contact.contactId', type: 'virtualized-select' }}, o); }}
                        {...inputPropsVirtualizedSelect}                        
                    />
                </div>

                {/* <div>
                    TODO: INACTIVE
                </div> */}
            </div>
        </DetailFormCommon.AssociationDetailFormSection>
    );
};



// WEBPACK FOOTER //
// ./src/association/detail-form/association-details.tsx